const copelec = {
  FORMS: [],
  CSS: {
    id: '507f1f77bcf86cd799439011',
    name: 'tiendaCopelec',
    avatar: {
      name: 'Celeste',
      header: 'https://chatbotqa.gatblac.com/static/avatar/copelec/logo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/copelec/avatar-tienda-copelec.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/copelec/chat-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/copelec/chat-close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#00a1d3',
        borderColor: '#00a1d3'
      }
    }
  }
}

export default copelec
